import { render, staticRenderFns } from "./PDisplaySum.vue?vue&type=template&id=61acdd62"
import script from "./PDisplaySum.vue?vue&type=script&lang=js"
export * from "./PDisplaySum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports